import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import adminApi from '../../lib/adminApi';
import { toast } from 'sonner';
import { ShieldCheck, ArrowLeft } from 'lucide-react';
import { Card } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Button } from '../../components/ui/button';
import { Label } from '../../components/ui/label';

export default function GestoreLogin() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const { data } = await adminApi.post('/admin/login', { username, password });
      localStorage.setItem('rmp_admin_token', data.access_token);
      toast.success(t('gestore.loginSuccess'));
      navigate('/gestore', { replace: true });
    } catch (err) {
      const msg = err?.response?.data?.detail || t('gestore.loginInvalid');
      setError(msg); toast.error(msg);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-dvh flex items-center justify-center bg-foreground/[0.03] p-6">
      <Card className="w-full max-w-md p-8 border-2">
        <button onClick={() => navigate('/login')} className="text-sm text-muted-foreground hover:text-foreground flex items-center gap-1 mb-6"><ArrowLeft className="h-4 w-4" /> {t('gestore.loginBack')}</button>
        <div className="h-12 w-12 rounded-xl bg-foreground text-background flex items-center justify-center mb-4"><ShieldCheck className="h-6 w-6" /></div>
        <h2 className="font-display text-2xl font-semibold">{t('gestore.loginTitle')}</h2>
        <p className="text-muted-foreground text-sm mt-1 mb-6">{t('gestore.loginDesc')}</p>
        <form onSubmit={submit} className="space-y-4">
          <div><Label>{t('gestore.loginUsername')}</Label><Input data-testid="gestore-username-input" value={username} onChange={(e) => setUsername(e.target.value)} className="mt-1.5 h-12" placeholder="gestore" /></div>
          <div><Label>{t('gestore.loginPassword')}</Label><Input type="password" data-testid="gestore-password-input" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 h-12" placeholder="••••••••" /></div>
          {error && <div className="text-sm text-destructive bg-destructive/10 rounded-lg px-3 py-2">{error}</div>}
          <Button type="submit" data-testid="gestore-submit-button" disabled={loading} className="w-full h-12 rounded-xl">{loading ? t('gestore.loginAccessing') : t('gestore.loginButton')}</Button>
        </form>
      </Card>
    </div>
  );
}
